import React from 'react';
import { Query } from 'react-apollo';
import PropTypes from 'prop-types';

const ErrorController = ({
  children,
  query,
  context,
  variables,
  apolloClient,
  handler,
}) => {
  return (
    <Query
      query={query}
      context={context}
      variables={variables}
      client={apolloClient}
    >
      {({ loading, error, data }) => handler(loading, error, data) || children}
    </Query>
  );
};

export const errorControllerPropTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  query: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  variables: PropTypes.object,
  handler: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  context: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  apolloClient: PropTypes.object,
};

ErrorController.propTypes = errorControllerPropTypes;

ErrorController.defaultProps = {
  variables: {},
  context: null,
  apolloClient: null,
};

export default ErrorController;
